var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview"},[_c('GridTextBox',[_c('h1',{class:_vm.className},[_vm._v(" Zyro ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }